import { Pipe, PipeTransform } from "@angular/core";
import { EmgStatus } from "app/main/shared/enums/SingularMessage.enum";

export const statusColor: Record<EmgStatus, string> = {
  [EmgStatus.Delivered]: "success",
  [EmgStatus.Deleted]: "danger",
  [EmgStatus.Expired]: "warning",
  [EmgStatus.Canceled]: "warning",
  [EmgStatus.InProcess]: "warning",
  [EmgStatus.Orphaned]: "danger",
  [EmgStatus.Queued]: "warning",
  [EmgStatus.Failed]: "danger",
  [EmgStatus.Rejected]: "warning",
  [EmgStatus.Relayed]: "success",
  [EmgStatus.Unknown]: "success",
};

@Pipe({
  name: "emgStatusBg",
})
export class EmgStatusBgPipe implements PipeTransform {
  transform(statusNumber: number): unknown {
    const color = statusColor[statusNumber] ?? "secondary";
    return `status-color-${color}`;
  }
}
